import React, { useState,useEffect } from 'react';
import QrScanner from 'react-qr-scanner';
import { useUser } from './UserProvider.tsx'; 
import { useNavigate } from 'react-router-dom'; 

const GoAttend: React.FC = () => {
  const [scanResult, setScanResult] = useState<string | null>(null);
  const [programName, setProgramName] = useState<string>('');
  const { isAuthenticated } = useUser(); // Access user authentication state
  const navigate = useNavigate();


  useEffect(() => {
        if (!isAuthenticated) {
          navigate('/login'); // Redirect to login page
        }
      }, [isAuthenticated, navigate]);
  const handleScan = (data: any) => {
    if (data) {
      setScanResult(data.text); // Extract text from the scanned data
    }
  };

  const handleError = (err: any) => {
    console.error('QR Code Scan Error:', err);
  };

  const handleProgramSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    alert(`Program Name Submitted: ${programName}`);
  };

  return isAuthenticated ? (
    <div className="min-h-screen  text-gray-200 p-6">
      {/* Header */}
      <header className="text-center mb-6">
        <div className="mb-4">
          <img
            src="https://tronova.azmiproductions.com/ikas/ikas.png" // Replace with your logo URL
            alt="GoAttend Logo"
            className="w-24 h-24 mx-auto"
          />
        </div>
        <h1 className="text-4xl font-bold">GO ATTEND</h1>
        <p className="text-gray-400 mt-2">Scan QR codes to check in for programs.</p>
      </header>

      {/* Program Form */}
      <div className="bg-gray-800 p-6 rounded-lg shadow-md max-w-md mx-auto mb-6">
        <form onSubmit={handleProgramSubmit} className="space-y-4">
          <div>
            <label htmlFor="program" className="block text-gray-400 mb-2">
              Program Name
            </label>
            <input
              type="text"
              id="program"
              placeholder="Enter program name"
              value={programName}
              onChange={(e) => setProgramName(e.target.value)}
              className="w-full p-3 rounded-lg bg-gray-700 text-gray-200 focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>
          <button
            type="submit"
            className="w-full bg-blue-600 hover:bg-blue-700 text-white py-3 rounded-lg font-semibold transition shadow-md hover:shadow-lg"
          >
            Submit Program Name
          </button>
        </form>
      </div>

      {/* Scanner Area */}
      <div className="flex flex-col items-center justify-center">
        <div className="bg-gray-800 p-4 rounded-lg shadow-lg">
          <QrScanner
            delay={300}
            onError={handleError}
            onScan={handleScan}
            style={{ width: '300px', height: '300px' }}
          />
        </div>
        <p className="text-gray-400 text-sm mt-4">
          Align the QR code within the frame to scan.
        </p>
      </div>

      {/* Scan Result Section */}
      <div className="mt-10">
        {scanResult ? (
          <div className="bg-gray-800 p-6 rounded-lg shadow-md max-w-md mx-auto">
            <h2 className="text-xl font-bold text-green-500 text-center">
              Scan Successful!
            </h2>
            <p className="text-gray-300 mt-4 text-center break-words">
              <span className="text-gray-400 font-bold">Result:</span> {scanResult}
            </p>
          </div>
        ) : (
          <div className="bg-gray-800 p-6 rounded-lg shadow-md max-w-md mx-auto">
            <h2 className="text-xl font-bold text-yellow-500 text-center">
              Ready to Scan
            </h2>
            <p className="text-gray-300 mt-4 text-center">
              No QR code detected yet. Please align the QR code within the scanner frame.
            </p>
          </div>
        )}
      </div>

      {/* Additional Tips */}
      <div className="mt-12 text-center">
        <h3 className="text-lg font-bold text-gray-400 mb-2">Tips for Scanning:</h3>
        <ul className="list-disc list-inside text-gray-400">
          <li>Ensure proper lighting for accurate scanning.</li>
          <li>Hold your device steady while scanning.</li>
          <li>Align the QR code completely within the frame.</li>
        </ul>
      </div>
    </div>
  ) : null; 
};

export default GoAttend;
